import { Component, ChangeDetectionStrategy, Input, inject } from '@angular/core';
import { takeUntil } from 'rxjs/operators';
import { MessageContentUnion } from '@airgram/core/types/outputs';
import { MessageVideo } from '@airgram/core/types/outputs/MessageContent';
import { FilePart } from '@airgram/web';
import { FileReaderService } from '@src/core/services';
import { MultimediaSource } from '@src/models';
import { BaseResizableComponent } from '@src/app/modules/base';

@Component({
  selector: 'app-message-video',
  templateUrl: './message-video.component.html',
  styleUrls: ['../styles/message-content.scss', './message-video.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MessageVideoComponent extends BaseResizableComponent {
  private readonly fileReaderService = inject(FileReaderService);

  @Input() set message(mess: MessageContentUnion | undefined) {
    this.messageVideo = mess as MessageVideo;
  }

  messageVideo?: MessageVideo;
  messageVideoSource?: MultimediaSource;
  messageVideoPosterSource?: MultimediaSource;

  override ngOnInit(): void {
    super.ngOnInit();

    this.initVideo();
  }

  private initVideo(): void {
    if (!this.messageVideo) return;

    this.fileReaderService
      .getFilePart(this.messageVideo?.video?.thumbnail?.file)
      .pipe(takeUntil(this.destroyed$$))
      .subscribe(filePart => this.setPosterSource(filePart));

    this.fileReaderService
      .getFilePart(this.messageVideo?.video?.video)
      .pipe(takeUntil(this.destroyed$$))
      .subscribe(filePart => this.setVideoSource(filePart));
  }

  private setVideoSource(filePart?: FilePart): void {
    this.messageVideoSource = { src: this.fileReaderService.getFileSource(filePart) };
    this.cdr.markForCheck();
  }

  private setPosterSource(filePart?: FilePart): void {
    this.messageVideoPosterSource = { src: this.fileReaderService.getFileSource(filePart) };
    this.cdr.markForCheck();
  }
}
